import { DownloadOutlined, InboxOutlined } from '@ant-design/icons';
import { Button, message, Radio, Upload } from 'antd';
import { FC, useState } from 'react';
import { downloadTemplate, TemplateFormat } from '../downloadTemplate';
import { parseSheet, ParsedRow } from '../parseSheet';

interface IProps {
	onParsed: (rows: ParsedRow[]) => void;
}

export const UploadStep: FC<IProps> = ({ onParsed }) => {
	const [format, setFormat] = useState<TemplateFormat>('xlsx');
	const [loading, setLoading] = useState(false);

	const accept =
		format === 'xlsx'
			? '.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			: '.csv,text/csv';

	return (
		<div>
			<div className='mb-4 flex items-center justify-between'>
				<div>
					<div className='font-semibold mb-1'>Tipo de arquivo:</div>
					<Radio.Group
						value={format}
						onChange={(e) => setFormat(e.target.value)}
					>
						<Radio value='xlsx'>XLSX</Radio>
						<Radio value='csv'>CSV</Radio>
					</Radio.Group>
				</div>
				<Button
					icon={<DownloadOutlined />}
					onClick={() => downloadTemplate(format)}
				>
					Baixar Template
				</Button>
			</div>

			<Upload.Dragger
				accept={accept}
				multiple={false}
				showUploadList={false}
				beforeUpload={async (file) => {
					setLoading(true);
					try {
						const rows = await parseSheet(file);
						if (rows.length === 0) {
							message.warning('Nenhuma linha encontrada no arquivo.');
							return false;
						}
						onParsed(rows);
					} catch (err) {
						console.error('Erro ao ler arquivo:', err);
						message.error('Não foi possível ler o arquivo.');
					} finally {
						setLoading(false);
					}
					return false;
				}}
				disabled={loading}
			>
				<p className='ant-upload-drag-icon'>
					<InboxOutlined />
				</p>
				<p className='ant-upload-text'>
					Clique ou arraste o arquivo para esta área
				</p>
				<p className='ant-upload-hint'>
					Formato aceito: {format.toUpperCase()}. Colunas:
					Nacionalidade · Documento · Nome · Email.
				</p>
			</Upload.Dragger>
		</div>
	);
};
